import React from 'react';
import { User, Heart, RotateCcw, Clock } from 'lucide-react';

const ModeToggle = ({ currentMode, onModeChange, onReset, onTimeOverrideToggle, debugTimeOverride }) => {
  const modes = [
    { id: 'primary', name: 'Primary', icon: Heart, color: 'text-pink-500' },
    { id: 'support', name: 'Support', icon: User, color: 'text-blue-500' }
  ];

  return (
    <div className="fixed top-4 right-4 z-50 bg-white bg-opacity-90 backdrop-blur-sm rounded-2xl shadow-xl p-3 border-2 border-gray-200">
      <div className="flex flex-col gap-2">
        <p className="text-xs font-semibold text-gray-700 mb-1 px-2">Debug Mode</p>
        {modes.map((mode) => {
          const Icon = mode.icon;
          const isActive = currentMode === mode.id;
          return (
            <button
              key={mode.id}
              onClick={() => onModeChange(mode.id)}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all ${
                isActive
                  ? 'bg-indigo-100 text-indigo-700 font-semibold'
                  : 'hover:bg-gray-100 text-gray-700'
              }`}
              aria-label={`Switch to ${mode.name} mode`}
            >
              <Icon className={`w-4 h-4 ${mode.color}`} />
              <span className="text-sm">{mode.name}</span>
            </button>
          );
        })}
        {onReset && (
          <button
            onClick={onReset}
            className="flex items-center gap-2 px-3 py-2 rounded-lg transition-all hover:bg-red-100 text-red-700 border-t border-gray-200 mt-1 pt-2"
            aria-label="Reset today's doses"
          >
            <RotateCcw className="w-4 h-4 text-red-600" />
            <span className="text-sm">Reset Doses</span>
          </button>
        )}
        {onTimeOverrideToggle && (
          <button
            onClick={onTimeOverrideToggle}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all border-t border-gray-200 mt-1 pt-2 ${
              debugTimeOverride
                ? 'bg-indigo-100 text-indigo-700 hover:bg-indigo-200'
                : 'hover:bg-gray-100 text-gray-700'
            }`}
            aria-label="Set time to 11:30 AM"
          >
            <Clock className={`w-4 h-4 ${debugTimeOverride ? 'text-indigo-600' : 'text-gray-600'}`} />
            <span className="text-sm">Set Time to 11:30 AM</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default ModeToggle;

